export default {
  form: {
    shipping_company_name: {
      label: 'Yritys',
      placeholder: 'Anna yrityksen nimi',
    },
    shipping_phone_number: {
      label: 'Puhelinnumero',
      placeholder: 'Anna puhelinnumero',
    },
    shipping_salutation: {
      label: 'Puhuttelu',
      options: {
        mr: 'Herra',
        mrs: 'Rouva',
      },
    },
    shipping_first_name: {
      label: 'Etunimi',
      placeholder: 'Anna etunimi',
    },
    shipping_last_name: {
      label: 'Sukunimi',
      placeholder: 'Anna sukunimi',
    },
  },
  buttons: {
    back: 'Takaisin',
    next: 'Seuraava',
  },
};
